var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"primaryOrder"},[_c('base-list-management',{ref:"baseListManagement",attrs:{"configData":_vm.c_primaryOrderConfigData},on:{"update:configData":function($event){_vm.c_primaryOrderConfigData=$event},"update:config-data":function($event){_vm.c_primaryOrderConfigData=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }